module.exports = __webpack_public_path__ + "img/photo03_pc.cb1aeeda.jpg";